<template>
  <v-container>
    <v-row>
      <ProjectStatCard
        icon="mdi-currency-usd"
        color="var(--color-secondary-green)"
        title="Budget:"
        :value="formatValue(statics.budget)"
        v-if="hasPermission('project.view_budget')"
      />
      <ProjectStatCard
        icon="mdi-cash-clock"
        color="var(--color-secondary-orange)"
        title="Est. Cost:"
        :value="formatValue(statics.estimated_cost)"
        v-if="hasPermission('project.view_est_cost')"
      />
      <ProjectStatCard
        icon="mdi-cash"
        color="var(--color-primary-blue)"
        title="Actual Cost:"
        :value="formatValue(statics.actual_cost)"
        v-if="hasPermission('project.view_actual_cost')"
      />
      <ProjectStatCard
        icon="mdi-timer"
        color="var(--color-secondary-red)"
        title="Due In:"
        :value="statics.remaining_durations"
      />
    </v-row>
  </v-container>
</template>

<script>
import ProjectStatCard from "@/components/shared/ProjectStatCard.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: {
    ProjectStatCard,
  },
  props: {
    statics: Object,
  },
  computed: {
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
      hasPermission: "hasPermission",
    }),
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  methods: {
    formatValue(value) {
      if (value === "N/A") {
        return "N/A";
      }
      return value != null
        ? `${this.currencyCode} ${parseFloat(value).toFixed(2)}`
        : "";
    },
  },
};
</script>
